import { PROHIBITED_BUSINESS_INDUSTRIES } from '../constants/businessVertical';

/**
 * Checks if the given business industry is prohibited.
 *
 * @param {string} businessIndustryValue - The business industry to check.
 * @returns {boolean} Returns true if the business industry is prohibited, false otherwise.
 */
export const checkProhibitedBusinessIndustry = (businessIndustryValue) =>
  PROHIBITED_BUSINESS_INDUSTRIES.includes(businessIndustryValue);
